const OVERWRITE_EXISTING = [
  { label: 'Overwriting the existing dataset', value: 'false' },
  { label: 'Creating a new dataset', value: 'true' },
];
const REGULATIONS = [
  {
    label: 'Classification',
    key: 'Classification', // this is scorecard catergory only we just renamed it.
    isTs: false,
  },
  // {
  //   label: 'Regulatory Capital',
  //   key: 'Regulatory Capital',
  //   isTs: false,
  // },
  {
    label: 'Regression',
    key: 'Regression', // this is time series catergory only we just renamed it.
    isTs: true,
  },
  // {
  //   label: 'CCAR',
  //   key: 'CCAR',
  //   isTs: true,
  // },
  // {
  //   label: 'IFRS9',
  //   key: 'IFRS9',
  //   isTs: true,
  // },
  // {
  //   label: 'Stress Testing (ICAAP)',
  //   key: 'ICAAP',
  //   isTs: true,
  // },
  {
    label: 'All Models',
    key: 'AllModels', // this is time series catergory only we just renamed it.
    isTs: true,
  },
];

const DATASET_REQUIRED_FIELDS = [
  'id',
  'name',
  'table_display_name',
  'preprocessed',
  'published',
  'datalock',
  'dataset',
  'project_id',
  'stages',
];
const SPACING_SIZES = [
  { label: 1.0, value: 1.0 },
  { label: 1.15, value: 1.15 },
  { label: 1.5, value: 1.5 },
  { label: 2.0, value: 2.0 },
  { label: 2.5, value: 2.5 },
  { label: 3.0, value: 3.0 },
];

const DOCUMENT_ALIGNMENT = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Right' },
  { value: 'justify', label: 'Justify' },
];

const BEFORE_AFTER_SPACING = [
  { value: '0', label: '0' },
  { value: 0.05, label: 0.05 },
  { value: 0.1, label: 0.1 },
  { value: 0.13, label: 0.13 },
  { value: 0.16, label: 0.16 },
  { value: 0.18, label: 0.18 },
  { value: 0.2, label: 0.2 },
];

const FONT_SIZE = [
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
  { value: 11, label: 11 },
  { value: 12, label: 12 },
  { value: 13, label: 13 },
  { value: 14, label: 14 },
  { value: 15, label: 15 },
];

const DIALOG_ICON_BUTTON_CSS = {
  position: 'absolute',
  right: 16,
  top: 8,
};

const MODEL_UPLOAD_TYPE = [
  { value: 'Python', label: 'Python' },
  { value: 'R', label: 'R' },
  { value: 'SAS', label: 'SAS' },
  { value: 'Others', label: 'Others' },
];

const MODEL_TYPE = [
  { value: 'Champion', label: 'Champion' },
  { value: 'Challenger', label: 'Challenger' },
  { value: 'Candidate', label: 'Candidate' },
];
const DOCUMENT_TYPES = [
  { value: 'Model Development', label: 'Model Development' },
  { value: 'Model Selection', label: 'Model Selection' },
  { value: 'Model Assumptions', label: 'Model Assumptions' },
  { value: 'Model Validation', label: 'Model Validation' },
  { value: 'Model Monitoring', label: 'Model Monitoring' },
  { value: 'Model Retraining', label: 'Model Retraining' },
];

const DS_LOCKED_MSG =
  'Dataset is locked as some other operation is in progress. You can try later or unlock the dataset from Datasets bar or Data Ingestion.';

const DS_RECALIBRATION_MSG =
  'Dataset is undergoing recalibration. Please wait for the process to complete.';

// Type : "5" , this is for option we want to show in the metrics dropdown but not to show table for it.
const METRICS_DATA = [
  {
    value: 'confusion matrix',
    label: 'Confusion Matrix',
    type: '5',
  },
  {
    value: 'ROC-AUC',
    label: 'ROC AUC',
    type: '1',
  },
  {
    value: 'KS',
    label: 'KS',
    type: '1',
  },
  {
    value: 'Precision',
    label: 'Precision',
    type: '1',
  },
  {
    value: 'F1-Score',
    label: 'F1 Score',
    type: '1',
  },
  {
    value: 'Recall',
    label: 'Recall',
    type: '1',
  },
  {
    value: 'gini',
    label: 'Gini',
    type: '1',
  },
  {
    value: 'specificity & sensitivity',
    label: 'Specificity vs Sensitivity',
    type: '1',
  },
  {
    value: 'vif',
    label: 'VIF Test',
    type: '1',
  },
  {
    value: 'HL',
    label: 'HL Test',
    type: '1',
  },
  {
    value: 'PSI',
    label: 'PSI',
    type: '2',
  },
  {
    value: 'CSI',
    label: 'CSI',
    type: '2',
  },
  {
    value: 'ME',
    label: 'ME',
    type: '3',
  },
  {
    value: 'RMSE',
    label: 'RMSE',
    type: '3',
  },
  {
    value: 'MAE',
    label: 'MAE',
    type: '3',
  },
  {
    value: 'MAPE',
    label: 'MAPE',
    type: '3',
  },
  {
    value: 'RMSE/SD',
    label: 'RMSE/SD',
    type: '4',
  },
];

const commonJobCardHeight = 70;
const defaultJobsCount = 12;

const COMMON_DOC_FIELDS = [
  'id',
  'document_name',
  'document_author',
  'project_id__name',
  'creation_date',
  'last_updated_date',
  'last_updated_by',
  'model_name',
  'client_model_id',
  'model_version',
  'document_description',
  'project_id',
  'saved_for_temp',
];

const COMMON_UDF_FILES_FIELDS = ['id', 'name', 'show_in_op_bar', 'tags'];

const COMMON_TASK_TYPE = [
  {
    label: 'Initial Validation',
    key: 'Initial Validation',
    value: 'Initial Validation',
  },
  { label: 'Revalidation', key: 'Revalidation', value: 'Revalidation' },
  {
    label: 'Target Scope Validation',
    key: 'Target Scope Validation',
    value: 'Target Scope Validation',
  },
  {
    label: 'Dynamic Updating Validation',
    key: 'Dynamic Updating Validation',
    value: 'Dynamic Updating Validation',
  },
  {
    label: 'Monitoring Update Validation',
    key: 'Monitoring Update Validation',
    value: 'Monitoring Update Validation',
  },
];

const TASK_STATUS = [
  {
    key: 'Task Created',
    value: 'Task Created',
    label: 'Task Created',
  },
  {
    key: 'Validator Assigned',
    value: 'Validator Assigned',
    label: 'Validator Assigned',
  },
  {
    key: 'Project Assigned',
    value: 'Project Assigned',
    label: 'Project Assigned',
  },
  {
    key: 'Pipeline Triggered',
    value: 'Pipeline Triggered',
    label: 'Pipeline Triggered',
  },
  {
    key: 'Pipeline Published',
    value: 'Pipeline Published',
    label: 'Pipeline Published',
  },
  {
    key: 'Pipeline Result Published',
    value: 'Pipeline Result Published',
    label: 'Pipeline Result Published',
  },
  {
    key: 'Document Published',
    value: 'Document Published',
    label: 'Document Published',
  },
  {
    key: 'Task Completed',
    value: 'Task Completed',
    label: 'Task Completed',
  },
];

const DOCUMENT_TYPES_PUBLISHED = [
  {
    value: 'Model Development published',
    label: 'Model Development Published',
  },
  { value: 'Model Selection published', label: 'Model Selection Published' },
  {
    value: 'Model Assumptions published',
    label: 'Model Assumptions Published',
  },
  { value: 'Model Validation published', label: 'Model Validation Published' },
  { value: 'Model Monitoring published', label: 'Model Monitoring Published' },
  { value: 'Model Retraining published', label: 'Model Retraining Published' },
];

const MODULE_PERMISSION_DESCRIPTION = {
  ProjectOverview_EditProject: 'Allows user to modify project details.',
  ProjectOverview_DeleteProject:
    'Allows user to delete project with all related details.',
  ProjectOverview_ArtifactsSharing:
    'Allows user to share related artifacts like documents, datasets, models and UDFs.',
  ProjectOverview_ArchiveProject: 'Allows the user to archive the project.',
  ProjectOverview_CloneProject:
    'Allows the user to create a copy of the project. This creates a new, independent project with the same content as the original.',
  ProjectOverview_ShareProject: 'Allows user to share project.',
  ProjectOverview_ModelMonitoringDashboard:
    'Allows user to view and edit content in model monitoring dashboard.',
  ProjectOverview_MarkProjectComplete:
    "Allows a user to formally mark a project as finished. Once marked as completed, user can't edit or delete anything in this project.",

  DataManagement_DataIngestion:
    "Allows the user to access Data Ingestion page. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control and user will be able to ingest new datasets.",
  DataManagement_DataPreparation:
    "Allows the user to access Data Management and Data Preparation related operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  DataManagement_Grid:
    "Allows the user to access Grid and Grid related operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  EDA_PreliminarySteps:
    "Allows the user to access EDA and perform preliminary operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  EDA_TreatingOutliers:
    "Allows the user to access EDA and Treating Outliers operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  EDA_MissingValuesImputation:
    "Allows the user to access EDA and Missing Value Imputation operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  EDA_VariableAnalysis:
    "Allows the user to access EDA and Variable Analysis operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  EDA_StatisticalTests:
    "Allows the user to access EDA and Statistical Tests operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  EDA_TimeSeriesAnalysis:
    "Allows the user to access EDA and Time Series Analysis operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  FeatureEngineering_FeatureEngineering:
    "Allows the user to access Feature Engineering and Feature Engineering operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  SamplingSegmentation_Sampling:
    "Allows the user to access Sampling and Sampling operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  SamplingSegmentation_Segmentation:
    "Allows the user to access Segmentation and Segmentation operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  VariableReduction_VariableReduction:
    "Allows the user to access Variable Reduction and Variable Reduction operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  ModelEstimation_ModelEstimation:
    "Allows the user to access Model Estimation and Model Estimation operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  ModelTesting_PerformaceTesting:
    "Allows the user to access Model Testing and Performance Testing operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_AssumptionTesting:
    "Allows the user to access Model Testing and Assumption Testing operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_ModelComparison:
    "Allows the user to access Model Testing and Model Comparison operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_ScoringScaling:
    "Allows the user to access Model Testing and Scoring Scaling operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_BackTesting:
    "Allows the user to access Model Testing and Back Testing operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_SensitivityAnalysis:
    "Allows the user to access Model Testing and Sensitivity Analysis operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_Fairness:
    "Allows the user to access Model Testing and Fairness & Biasness operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_DriftAnalysis:
    "Allows the user to access Model Testing and Drift Analysis operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_ModelRecaliberation:
    "Allows the user to access Model Testing and Model Recalibration operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelTesting_Forecasting:
    "Allows the user to access Model Testing and Forecasting operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  ModelInterpretation_FeatureInterpretation:
    "Allows the user to access Model Interpretation and Feature Interpretation operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelInterpretation_IndividualPrediction:
    "Allows the user to access Model Interpretation and Individual Prediction operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelInterpretation_DecisionTrees:
    "Allows the user to access Model Interpretation and Decision Trees operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",
  ModelInterpretation_TimeSeriesAnalysis:
    "Allows the user to access Model Interpretation and Time Series Analysis operations. The page will be hidden if no access is granted. Users with 'View' access have read-only permissions, while 'Manage' access allows full control of all operations on the page.",

  ModelManager_UploadModel: 'Allows the user to upload models.',
  ModelManager_CompareModels:
    "Enables users to compare model's parameters, variables, datasets, properties, metadata and model files.",
  ModelManager_ViewModelDetails: 'Permits the user to view model details.',
  ModelManager_EditModelDetails:
    'Allows editing the information and metadata associated with a model.',
  ModelManager_ArchiveModel:
    'Enables the user to archive the model, no operation can be performed on an archived model.',
  ModelManager_CloneModel:
    'Allows the user to clone an existing model into the same or different project.',
  ModelManager_DeleteModel:
    'Permits permanently deleting a model from the system.',
  ModelManager_LinkUnlinkModelUDF:
    'Enables linking or unlinking a model with user-defined functions (UDFs) for extended functionality.',
  ModelManager_ViewDocument:
    'Allows viewing associated documents related to a model or process.',
  ModelManager_EditDocument:
    "Permits the user to edit model related document's name, type, version.",
  ModelManager_AddDocument:
    'Enables the user to add a document related to that model.',
  ModelManager_DeleteDocument:
    'Enables the user to delete a document related to that model.',
  ModelManager_DownloadDocument:
    'Permits the user to download model related documents.',
  ModelManager_StartStopDeployment:
    'Enables starting or stopping the deployment of a model.',
  ModelManager_AddEditTestCase:
    'Allows adding or editing test cases for validating models or processes.',
  ModelManager_ViewTestCase:
    'Permits viewing the details and results of test cases.',
  ModelManager_DeleteTestCase:
    'Allows permanently deleting test cases from the system.',
  ModelManager_ViewStats:
    'Enables users to view the percentage of models based on different metrics like library, language, deployment and status.',

  Pipeline_CreatePipeline: 'Allows the user to create a new pipeline.',
  Pipeline_EditPipeline:
    'Enables the user to modify the node structure and data of the selected pipeline.',
  Pipeline_UpdatePipelineSettings:
    'Permits the user to modify the settings of a pipeline.',
  Pipeline_RunPipeline: 'Allows the user to execute a pipeline.',
  Pipeline_AddNodeToPipeline:
    'Enables the user to add new nodes to a pipeline.',
  Pipeline_ViewExecutionHistory:
    'Allows the user to view the history of pipeline executions and their results.',
  Pipeline_DeletePipeline: 'Permits the user to delete a pipeline.',
  Pipeline_DeleteNode: 'Allows the user to delete a node from a pipeline.',
  Pipeline_DeleExecutionHistory:
    'Enables the user to delete the execution records associated with the selected pipeline.',
  Pipeline_UpdateNode:
    'Permits the user to update node related data such as name, parameters, arguments, and document mapping of the selected pipeline.',
  Pipeline_SharePipeline:
    'Allows the user to share the pipeline with other users.',
  Pipeline_ClonePipeline:
    'Enables the user to create a copy of the pipeline without continuous synchronization.',
  Pipeline_StopExecution:
    'Allows the user to stop the execution of the selected pipeline.',
  Pipeline_SavePipeline:
    'Permits the user to save the latest modifications made to the pipeline.',
  Pipeline_ViewExecutionResult:
    'Allows the user to view the results of a pipeline execution.',
  Pipeline_OpenLinkedDocument:
    'Enables the user to open documents mapped to the selected pipeline.',
  Pipeline_InterconnectPipeline:
    'Allows the user to add the execution of an existing pipeline into the selected pipeline as a node, enabling interconnectivity between the two pipelines.',
  Pipeline_ReadyToUse:
    'Allows user to mark a newly generated dataset via pipeline executions as ready to use.',
  Pipeline_PublishPipeline: 'Allows the user to publish the selected pipeline.',
  Pipeline_MarkAsFinal:
    'Allows the user to mark pipeline execution result as final.',
  Pipeline_ListPublishedPipeline: 'Allows to view only published pipeline.',
  Pipeline_ListPipeline: 'Allows the user to view non published pipelines.',

  Downloads_Downloads:
    'Allows the user to access Downloads page and download the required data.',

  UDF_CreateUDF: 'Allows the user to create UDFs.',
  UDF_ViewDetails: 'Permits the user to view details of the UDFs.',
  UDF_DebugUDF: 'Allows the user to access JupyterHub for debugging the code.',
  UDF_RunUDF: 'Allows the user to run a UDF.',
  UDF_SaveUDF: 'Permits the user to save changes to UDF.',
  UDF_EditUDF: 'Enables the user to edit UDFs.',
  UDF_VersionHistory: 'Allows the user to see the code history of UDFs.',
  UDF_ShareUDF: 'Permits the user to share UDFs with other users.',
  UDF_CloneUDF: 'Enables the user to clone UDFs in different projects.',
  UDF_RerunUDF: 'Allows the user to rerun the successfully executed UDF jobs.',
  UDF_CompareJobs:
    'Enables the user to compare results between 2 or more executed UDFs.',
  UDF_AddJobToPipeline: 'Allows the user to add UDFs jobs to pipeline.',
  UDF_DeleteJobs: 'Permits the user to delete the UDFs Job.',
  UDF_FileUpload:
    'Enables the user to upload files in the console file section to be used to create UDFs.',
  UDF_FileDownload: 'Allows the user to download the files to local system.',
  UDF_FileDelete:
    'Permits the user to delete files, uploaded in console file section.',
  UDF_DeleteUDF: 'Enables the user to delete the UDFs permanently.',
  UDF_ReviewUDF: 'Allows the reviewer to review the UDF when requested.',
  UDF_CancelUDFReview:
    'Permits the users to cancel UDF review request made on that UDF.',
  UDF_RequestUDFReview:
    'Enables the user to request review on the UDF by collaborators or reviewers.',
  UDF_ViewJobQueue:
    'Allows the users to see the history of executed jobs of UDFs.',
  UDF_ViewJobResults:
    'Permits the user to see the results of successfully executed UDF jobs.',
  UDF_ViewUDFList: 'Allows the user to see the list of existing UDFs.',

  AutomatedDoc_CreateDoc: 'Allows the user to create new documents.',
  AutomatedDoc_DeleteDoc: 'Permits the user to delete documents.',
  AutomatedDoc_EditDoc:
    'Enables the user to edit documents details such as name, author and description.',
  AutomatedDoc_CreateTemplate: 'Allows the user to save document as template.',
  AutomatedDoc_DeleteTemplate: 'Permits the user to delete template.',
  AutomatedDoc_EditDocumentContent:
    'Enables the user to edit and save the contents of the document.',
  AutomatedDoc_CommentOnResults:
    'Allows the user to save results to placeholders with certain comments and description.',
  AutomatedDoc_CloneDocument: 'Enables the user to clone documents.',
  AutomatedDoc_PublishDocument:
    'Allows the user to publish a document to the linked task.',

  TaskManager_CreateTask: 'Enables the user to create tasks.',
  TaskManager_ViewTaskDetails: 'Permits the user to view task details.',
  TaskManager_EditTaskDetails: 'Enables the user to edit task details.',
  TaskManager_InitiateProject:
    'Allows the user to initiate a new project from the created task.',
  TaskManager_CloseTask:
    'Permits the user to mark a task as completed or closed.',
  TaskManager_UploadDocument:
    'Allows the user to publish/upload external documents to the task.',
  TaskManager_DownloadDocument:
    'Permits the user to download documents being published to a task.',
  TaskManager_ViewDocument:
    'Enables the user to view documents being published to a task.',
  TaskManager_DeleteDocument:
    'Allows the user to delete documents being published to a task.',
  TaskManager_ViewMyTask: 'Permits the user to view task related to the user.',
  TaskManager_ViewAllTasks: 'Enables the user view all the tasks.',
  TaskManager_ViewRelatedPipelines:
    'Allows the user to view list of pipelines being published to task.',
  TaskManager_UnpublishPipeline:
    'Permits the user to unpublish the published pipeline.',
  TaskManager_ViewFinalResults:
    'Enables the user to view final published results to the task.',
  TaskManager_UnpublishResult:
    'Allows the user to mark published results as unpublished.',
  TaskManager_ViewRelatedDocuments:
    'Permits the user to view list of documents being published to task.',
  TaskManager_ViewBoard:
    'Enables the user to view the task board, which displays task cards categorized by status of the tasks.',
};

const NOTIFICATION_TYPE = [
  {
    label: 'All notifications',
    key: 'all_notifications',
    value: 'all',
  },
  {
    label: 'Read notifications',
    key: 'read_notifications',
    value: true,
  },
  {
    label: 'Unread notifications',
    key: 'unread_notifications',
    value: false,
  },
];

export {
  DS_LOCKED_MSG,
  MODULE_PERMISSION_DESCRIPTION,
  DS_RECALIBRATION_MSG,
  REGULATIONS,
  OVERWRITE_EXISTING,
  SPACING_SIZES,
  DOCUMENT_ALIGNMENT,
  BEFORE_AFTER_SPACING,
  FONT_SIZE,
  DIALOG_ICON_BUTTON_CSS,
  MODEL_UPLOAD_TYPE,
  MODEL_TYPE,
  DOCUMENT_TYPES,
  DATASET_REQUIRED_FIELDS,
  METRICS_DATA,
  commonJobCardHeight,
  defaultJobsCount,
  COMMON_DOC_FIELDS,
  COMMON_UDF_FILES_FIELDS,
  COMMON_TASK_TYPE,
  TASK_STATUS,
  DOCUMENT_TYPES_PUBLISHED,
  NOTIFICATION_TYPE,
};
